import cx from 'classnames'

export const WRAPPER_CLASS = 'collapsible-object'
const COLLAPSED_WRAPPER_CLASS = 'collapsible-object--collapsed'
const EXPANDED_WRAPPER_CLASS = 'collapsible-object--expanded'

const TRIGGER_CLASS = 'collapsible-object-trigger'

export const externalTriggerClasses = {
  getTriggerClasslist: () => TRIGGER_CLASS,
  getWrapperClasslist: (expanded: boolean) =>
    cx(WRAPPER_CLASS, expanded ? EXPANDED_WRAPPER_CLASS : COLLAPSED_WRAPPER_CLASS)
} as const

export const isExpanded = (collapsibleObjectRoot: HTMLElement) => {
  return collapsibleObjectRoot.classList.contains(EXPANDED_WRAPPER_CLASS)
}
export const expandCollapsibleObject = (objectRoot: HTMLElement) => {
  const trigger = objectRoot.querySelector(`.${TRIGGER_CLASS}`) as HTMLElement
  trigger?.click()
}
